// Override Settings
var bcSfSearchSettings = {
    search: {
        //suggestionMode: 'test',
        //suggestionPosition: 'left'
      suggestionMobileStyle: 'style2',
      suggestionWidth: 600
    }
};

// Customize style of Suggestion box
BCSfFilter.prototype.customizeSuggestion = function(suggestionElement, searchElement, searchBoxId) {
  /* if (!this.isMobile()) {
    var width = parseFloat(jQ(suggestionElement).css('width').replace(/\D/g, '')) / 2;    
    console.log('width', width);
    jQ(suggestionElement).css('width', width + 'px');
    jQ(suggestionElement).parent().css('width', width + 'px');
    // jQ(suggestionElement).css('top', (top - 2) + 'px');
  } */
};

/*
document.addEventListener('DOMContentLoaded', function() {
  function defaultPosition() {
    if(jQ(window).width() <= 767){
      var headerTop = jQ('#header').offset().top;
      var headerSize = jQ('#header').outerHeight(true);
      var position = (headerTop + headerSize) + 'px';
    }else{
      var headerTop = jQ('#header').offset().top;
      var headerSize = jQ('#header').outerHeight(true);
      var position = (headerTop + headerSize - 10) + 'px';
    }
  }
  
  defaultPosition();
  
  jQ(window).scroll(function() {    
    var windowScroll = jQ(window).scrollTop();
    var headerTop = jQ('#header').offset().top;
    var headerSize = jQ('.site-header').outerHeight(true);
    var headerIDSize = jQ('#header').height();
    var position = '';
    
    if(jQ(window).width() <= 767){
      if (windowScroll <= 145) {
        defaultPosition();
        var suggestionPosition = (headerTop + headerSize - 10) + 'px';
        jQ('.bc-sf-search-suggestion-wrapper').css('top', suggestionPosition);
        return;
      } else {
        position = (windowScroll + headerSize) + 'px';
      	var suggestionPosition = (windowScroll + headerSize - 5) + 'px';
      }
    }else{
      if (windowScroll <= 145) {
        defaultPosition();
        var suggestionPosition = (headerTop + headerSize - 35) + 'px';
        jQ('.bc-sf-search-suggestion-wrapper').css('top', suggestionPosition);
        return;
      } else {
        position = (windowScroll + headerSize) + 'px';
      	var suggestionPosition = (windowScroll + headerSize - 25) + 'px';
      }
    }
    jQ('.bc-sf-search-suggestion-wrapper').css('top', suggestionPosition);
  });
});

// Initialize Search box with Autocomplete
BCSfFilter.prototype.initSearchBox = function(id) {
    if (this.getSettingValue('search.enableSuggestion')) {      
        var self = this;
      	removeThemeSearch(self);
      
        if (typeof id === 'undefined') {
            jQ('input[name="' + this.searchTermKey + '"]').each(function(i) {
                if (!jQ(this)[0].hasAttribute('data-no-bc-search')) {                  
                    var id = 'bc-sf-search-box-' + i;
                    jQ(this).attr({
                        'id': id,
                        'aria-live': 'polite',
                        'placeholder': self.getSettingValue('label.suggestion.searchBoxPlaceholder')
                    });
                    self.buildSearchBox('#' + id)
                }
            });
        } else {
            this.buildSearchBox(id);
        }
        if (this.isMobile()) {
            // Clear cache when going back from another page
            window.onpageshow = function(event) {
                if (event.persisted) {
                    window.location.reload();
                }
            };
            // Build Suggestion mobile on top
            if (this.getSettingValue('search.suggestionMobileStyle') == 'style1') {
                this.buildSuggestionMobile();
            }
        }
    }
};

function removeThemeSearch(self) {
  jQ('input[name="' + self.searchTermKey + '"]').each(function(i) {
	if (!jQ(this)[0].hasAttribute('data-no-bc-search')) {
      var clone = jQ(this).clone();
      jQ(this).replaceWith(clone);
    }
  });
}

BCSfFilter.prototype.afterBuildSearchBox = function(id) {
	jQ("#searchPopup").appendTo(".site-header");
};

// Wrap Suggestion
BCSfFilter.prototype.buildSuggestionWrapper = function(ul, searchBoxId) {
    var self = this;
    var suggestionPosition = getSuggestionPosition(searchBoxId);
    if (self.isSuggestionStyle2()) {
        var suggestionStyle2MainContainerSelector = self.getSettingValue('search.suggestionStyle2MainContainerSelector') || 'header:first';
        jQ(suggestionStyle2MainContainerSelector).css('position', 'relative');
    }
    var wrapperClass = this.class.searchSuggestionWrapper;
    var popoverClass = 'bc-sf-search-suggestion-popover';
    if (!jQ(ul).parent().hasClass(wrapperClass)) {
        var mobileClass = this.checkIsFullWidthSuggestionMobile(searchBoxId) ? this.class.searchSuggestionMobile : '';
        jQ(ul).wrap('<div class="' + wrapperClass + ' ' + mobileClass + '"></div>');
    }
    if (self.isSuggestionStyle2() && jQ('.' + self.class.searchSuggestionWrapper).length > 0) {
        var wrapperSearch = jQ('.' + self.class.searchSuggestionWrapper);
        wrapperSearch.addClass(self.class.searchSuggestionWrapper + '-' + self.getSettingValue('search.suggestionStyle'))
            .addClass(self.class.searchSuggestionWrapper + '-' + self.getSettingValue('search.suggestionStyle') + '-width-fullwidth')
            .addClass(self.class.searchSuggestion + '-products-per-row-' + self.getSettingValue('search.suggestionStyle2ProductPerRow'))
            .addClass(self.class.searchSuggestion + '-reverse-product-block-' + self.getSettingValue('search.suggestionStyle2ReverseProductBlock'));
    }
    jQ(ul).siblings().show();
    // Set open position of parent of Suggestion box
    var topPosition = 0;
    if (suggestionPosition == 'left') {
        jQ(ul).parent().position({
            my: 'left ' + topPosition,
            at: 'left bottom',
            of: jQ(searchBoxId)[0]
        });
        var buildPopOverClassPosition = function() {
            jQ('.' + popoverClass).position({
                my: 'left+20 top-8' + topPosition,
                at: 'left bottom',
                of: jQ(searchBoxId)[0]
            });
        };
    } else {
        jQ(ul).parent().position({
            my: 'right ' + topPosition,
            at: 'right bottom',
            of: jQ(searchBoxId)[0]
        });
        var buildPopOverClassPosition = function() {
            jQ('.' + popoverClass).position({
                my: 'right-20 top-8',
                at: 'right bottom',
                of: jQ(searchBoxId)[0]
            });
        };
    }
    buildPopOverClassPosition();
    // Set width for wrapper
    if (!self.isSuggestionStyle2()) {
        var width = this.getSuggestionWidth(searchBoxId);
        jQ(ul).parent().outerWidth(width);
    } else {
        jQ(window).resize(function() {
            buildPopOverClassPosition();
        });
    }
    if(jQ(window).width() <= 767){
      jQ(".bc-sf-search-suggestion-wrapper").appendTo("#searchPopup");
    }
};
*/

function removeThemeSearch(self) {
  jQ('input[name="' + self.searchTermKey + '"]').each(function(i) {
	if (!jQ(this)[0].hasAttribute('data-no-bc-search')) {
      var clone = jQ(this).clone();
      jQ(this).replaceWith(clone);
    }
  });
}

// Initialize Search box with Autocomplete
BCSfFilter.prototype.initSearchBox = function(id) {
    if (this.getSettingValue('search.enableSuggestion')) {      
        var self = this;
      	removeThemeSearch(self);
      
        if (typeof id === 'undefined') {
            jQ('input[name="' + this.searchTermKey + '"]').each(function(i) {
                if (!jQ(this)[0].hasAttribute('data-no-bc-search')) {                  
                    var id = 'bc-sf-search-box-' + i;
                    jQ(this).attr({
                        'id': id,
                        'aria-live': 'polite',
                        'placeholder': self.getSettingValue('label.suggestion.searchBoxPlaceholder')
                    });
                    self.buildSearchBox('#' + id)
                }
            });
        } else {
            this.buildSearchBox(id);
        }
        if (this.isMobile()) {
            // Clear cache when going back from another page
            window.onpageshow = function(event) {
                if (event.persisted) {
                    window.location.reload();
                }
            };
            // Build Suggestion mobile on top
            if (this.getSettingValue('search.suggestionMobileStyle') == 'style1') {
                this.buildSuggestionMobile();
            }
        }
    }
};

BCSfFilter.prototype.afterBuildSearchBox = function(id) {
	jQ("#searchPopup").appendTo(".site-header");
};

// Wrap Suggestion
BCSfFilter.prototype.buildSuggestionWrapper = function(ul, searchBoxId) {
    var self = this;
    var suggestionPosition = getSuggestionPosition(searchBoxId);
    if (self.isSuggestionStyle2()) {
        var suggestionStyle2MainContainerSelector = self.getSettingValue('search.suggestionStyle2MainContainerSelector') || 'header:first';
        jQ(suggestionStyle2MainContainerSelector).css('position', 'relative');
    }
    var wrapperClass = this.class.searchSuggestionWrapper;
    var popoverClass = 'bc-sf-search-suggestion-popover';
    if (!jQ(ul).parent().hasClass(wrapperClass)) {
        var mobileClass = this.checkIsFullWidthSuggestionMobile(searchBoxId) ? this.class.searchSuggestionMobile : '';
        jQ(ul).wrap('<div class="' + wrapperClass + ' ' + mobileClass + '"></div>');
        // Add Arrow
        jQ(ul).parent().prepend('<div class="' + popoverClass + '" data-direction="' + suggestionPosition + '"></div>');
    }
    if (self.isSuggestionStyle2() && jQ('.' + self.class.searchSuggestionWrapper).length > 0) {
        var wrapperSearch = jQ('.' + self.class.searchSuggestionWrapper);
        wrapperSearch.addClass(self.class.searchSuggestionWrapper + '-' + self.getSettingValue('search.suggestionStyle'))
            .addClass(self.class.searchSuggestionWrapper + '-' + self.getSettingValue('search.suggestionStyle') + '-width-fullwidth')
            .addClass(self.class.searchSuggestion + '-products-per-row-' + self.getSettingValue('search.suggestionStyle2ProductPerRow'))
            .addClass(self.class.searchSuggestion + '-reverse-product-block-' + self.getSettingValue('search.suggestionStyle2ReverseProductBlock'));
    }
  	if(jQ(window).width() <= 767){
      jQ(".bc-sf-search-suggestion-wrapper").appendTo("#searchPopup");
    }
    jQ(ul).siblings().show();
    // Set open position of parent of Suggestion box
    var topPosition = this.checkIsFullWidthSuggestionMobile(searchBoxId) ? 'top' : 'top+12';
    if (suggestionPosition == 'left') {
        jQ(ul).parent().position({
            my: 'left ' + topPosition,
            at: 'left bottom',
            of: jQ(searchBoxId)[0]
        });
        var buildPopOverClassPosition = function() {
            jQ('.' + popoverClass).position({
                my: 'left+20 top-8' + topPosition,
                at: 'left bottom',
                of: jQ(searchBoxId)[0]
            });
        };
    } else {
        jQ(ul).parent().position({
            my: 'right ' + topPosition,
            at: 'right bottom',
            of: jQ(searchBoxId)[0]
        });
        var buildPopOverClassPosition = function() {
            jQ('.' + popoverClass).position({
                my: 'right-20 top-8',
                at: 'right bottom',
                of: jQ(searchBoxId)[0]
            });
        };
    }
    buildPopOverClassPosition();
    // Set width for wrapper
    if (!self.isSuggestionStyle2()) {
        var width = this.getSuggestionWidth(searchBoxId);
        jQ(ul).parent().outerWidth(width);
    } else {
        jQ(window).resize(function() {
            buildPopOverClassPosition();
        });
    }
};

// Build Search result for SEO title
BCSfFilter.prototype.buildSEOTitle = function(data) {
    var enableFixHeadTitle = this.getSettingValue('search.enableFixHeadTitle');
    if (enableFixHeadTitle) {
        var seoTitle = data.total_product <= 1 ? this.getLabel('label', 'search_seo_title_one', '{{ count }} Ergebnisse für &quot;{{ terms }}&quot;') : this.getLabel('label', 'search_seo_title_other', '{{ count }} Ergebnisse für &quot;{{ terms }}&quot;'),
            searchTerm = this.getSearchTerm();
        if (seoTitle && searchTerm !== null && searchTerm != '') {
            searchTerm = this.escape(searchTerm);
            seoTitle = seoTitle.replace(/{{ count }}/g, data.total_product).replace(/{{ terms }}/g, searchTerm);
            document.title = seoTitle.replace(/&quot;/g,'"');
        }
    }
};